import { fmtEur, fmtNum } from "@/lib/format";

const keyOf = (o) => `${o.fiche_code}${o.is_option ? " (option)" : ""}`;

export const opsMatrix = (sims) => {
  const keys = [];
  sims.forEach((s) => (s.result?.operations || []).forEach((o) => { if (!keys.includes(keyOf(o))) keys.push(keyOf(o)); }));
  return keys.map((k) => ({
    key: k,
    cells: sims.map((s) => {
      const ops = (s.result?.operations || []).filter((o) => keyOf(o) === k);
      return ops.length ? { kwhc: ops.reduce((a, o) => a + o.kwhc, 0), prime: ops.reduce((a, o) => a + o.prime, 0), name: ops[0].name } : null;
    }),
  }));
};

export const OpsTable = ({ sims, refSim }) => {
  const rows = opsMatrix(sims);
  return (
    <div className="overflow-x-auto rounded-xl border border-border" data-testid="ops-table">
      <table className="w-full text-sm min-w-[640px]">
        <thead>
          <tr className="bg-secondary/60">
            <th className="text-left px-4 py-3 font-semibold w-56">Fiche</th>
            {sims.map((s) => <th key={s.id} className={`text-left px-4 py-3 font-semibold truncate max-w-[220px] ${s.id === refSim.id ? "bg-genis/10" : ""}`}>{s.name}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.key} className="border-t border-border" data-testid={`ops-row-${r.key}`}>
              <td className="px-4 py-2.5">
                <div className="font-semibold text-xs">{r.key}</div>
                <div className="text-[11px] text-muted-foreground truncate max-w-[220px]">{r.cells.find(Boolean)?.name}</div>
              </td>
              {r.cells.map((c, i) => (
                <td key={sims[i].id} className={`px-4 py-2.5 ${sims[i].id === refSim.id ? "bg-genis/5" : ""}`}>
                  {c ? (
                    <>
                      <div className="metric">{fmtNum(c.kwhc)} kWhc</div>
                      <div className="metric text-xs font-semibold text-genis">{fmtEur(c.prime)}</div>
                    </>
                  ) : <span className="text-muted-foreground">—</span>}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
